"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMetricsTracker = void 0;
exports.getCleanDigitalData = getCleanDigitalData;
exports.getRoot = getRoot;
exports.setupRoot = setupRoot;
var _enums = _interopRequireDefault(require("./types/enums"));
var _helpers = require("./helpers");
var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_USER_ID = '1';
var GLOBAL_KEY = 'sm_metrics_tracker_do_not_touch_this';

/**
 * Creates a new DigitalData object and populates default values for the user
 *
 * @param userId The ID of the current user
 * @returns A DigitalData object populated only with default values
 */
function getCleanDigitalData() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_USER_ID;
  return {
    page: {
      pageInfo: {
        pageId: '',
        attributes: {},
        pathname: ''
      }
    },
    events: [],
    components: [],
    user: {
      ep201: (0, _utils.default)('ep201'),
      ep202: (0, _utils.default)('ep202'),
      id: userId
    }
  };
}

/**
 * Returns the MetricsTracker root object. If it doesn't exist, creates it.
 *
 * @param glob A reference to the global object that MetricsTrackerRoot will by saved to
 * @returns The MetricsTrackerRoot
 */
function setupRoot(glob) {
  if (!glob[GLOBAL_KEY]) {
    var root = {
      subscribers: [],
      automaticSubscribers: [],
      config: {
        user: {
          id: '',
          isAuthenticated: false
        },
        dataAnalyticsAPIPath: null,
        loggingAPIPath: null,
        country: 'GB',
        legacyWeb: '',
        gtmId: ''
      },
      digitalData: getCleanDigitalData(DEFAULT_USER_ID)
    };
    glob[GLOBAL_KEY] = root;
  }
  return glob[GLOBAL_KEY];
}

/**
 * Returns the global MetricsTrackerRoot object
 *
 * @param glob A reference to the global object on which the MetricsTrackerRoot object exists
 * @returns
 */
function getRoot(glob) {
  if (!glob[GLOBAL_KEY]) {
    throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
  }
  return glob[GLOBAL_KEY];
}

/**
 * Creates a MetricsTrackerType object with common level functionality that is wrapped
 * in scope by the provided global object reference.
 *
 * @param glob A reference to the global namespace that the metrics tracker will be added to
 * @returns A MetricsTrackerType object with it's context bound to the passed in `glob` ref
 */
var createMetricsTracker = exports.createMetricsTracker = function createMetricsTracker(glob) {
  return {
    initialize: function initialize(config) {
      throw new Error('initialize not implemented');
    },
    reset: function reset() {
      throw new Error('reset not implemented');
    },
    update: function update(config) {
      // for some data points within an SPA, the configuration must be
      // updated post initialization
      var root = getRoot(glob);
      root.config = _objectSpread(_objectSpread({}, root.config), config);
      return root;
    },
    /**
     * Convenience method to update parts of the user config that can be decorated post-initialization
     *
     * @param userConfig The updated user configuration
     */
    updateUserConfig: function updateUserConfig(userConfigUpdate) {
      var root = getRoot(glob);
      root.config.user = _objectSpread(_objectSpread({}, root.config.user), userConfigUpdate);
      return root;
    },
    getSubscribers: function getSubscribers() {
      var _getRoot = getRoot(glob),
        subscribers = _getRoot.subscribers;
      return subscribers;
    },
    getAutomaticSubscribers: function getAutomaticSubscribers() {
      var _getRoot2 = getRoot(glob),
        automaticSubscribers = _getRoot2.automaticSubscribers;
      return automaticSubscribers;
    },
    track: function track(event) {
      var _event$data, _event$data2;
      var root = getRoot(glob);
      if (root.config.user.id === '') {
        throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
      }
      var maskedEvent = event;

      // mask email addresses
      if (event !== null && event !== void 0 && (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.email) {
        maskedEvent.data.email = (0, _helpers.maskEmail)(event.data.email);
      }
      if (event !== null && event !== void 0 && (_event$data2 = event.data) !== null && _event$data2 !== void 0 && (_event$data2 = _event$data2.data) !== null && _event$data2 !== void 0 && _event$data2.email) {
        maskedEvent.data.data.email = (0, _helpers.maskEmail)(event.data.data.email);
      }
      if (_enums.default[event.name]) {
        root.digitalData.events.push(event);
        if (_enums.default.COMPONENT_ADD === event.name) {
          root.digitalData.components.push(event.data);
        }
        if (event.name === _enums.default.PAGE_VIEW || event.name === _enums.default.VIRTUAL_PAGE_VIEW) {
          root.digitalData = (0, _helpers.pageViewMutation)(event, root.digitalData);
        }
        root.subscribers.forEach(function (subscriber) {
          subscriber(event, root.config);
        });
      }
    },
    automaticTrack: function automaticTrack(event) {
      var root = getRoot(glob);
      root.automaticSubscribers.forEach(function (subscriber) {
        subscriber(event, root.config);
      });
    },
    addSubscriber: function addSubscriber(subscriber) {
      /**
       * We always want to allow the subscribers to subscribe. If the user
       * did not accept GDPR, we don't fire events; hence, we never violate GDPR.
       * If, however, the user does allow tracking, we don't want to subscribers
       * to re-subscribe.
       */
      var root = getRoot(glob);
      root.subscribers.push(subscriber);
    },
    addAutomaticSubscriber: function addAutomaticSubscriber(subscriber) {
      var root = getRoot(glob);
      root.automaticSubscribers.push(subscriber);
    },
    getConfig: function getConfig() {
      return getRoot(glob).config;
    },
    getDigitalData: function getDigitalData() {
      return getRoot(glob).digitalData;
    },
    isInitialized: false
  };
};
//# sourceMappingURL=BaseMetricsTracker.js.map